import { AiOutlineClose } from "react-icons/ai";
import styled, { keyframes } from "styled-components";

import { AI_CONCIERGE_FONT_FAMILY } from "@/commands/AIConcierge/assistantWrapper.style";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0%);
  }
`;

export const StartWrapper = styled.div`
  position: fixed;
  left: 50%;
  top: 50%;
  z-index: 3;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const AssistantWrapper = styled.div<{ $isSignage: boolean }>`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${(props) =>
    props.$isSignage ? "white" : "rgba(255, 255, 255, 0.6)"};
  animation: ${fadeIn} 0.5s ease-in-out;
`;

export const AssistantIconWrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;

  & > div {
    // アイコンの位置を下に修正したい場合
    // position: absolute;
    // bottom: 0;

    width: 100%;d
    height: 100%;

    & > img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
`;

export const AssistantCloseButton = styled(AiOutlineClose).withConfig({
  shouldForwardProp: (prop) => !["isChatLogExpanded"].includes(prop),
})<{ isChatLogExpanded: boolean }>`
  position: absolute;
  top: 1rem;
  right: 1rem;
  font-size: 1.5rem;
  border: 1px solid #000;
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  padding: 0.25rem;
  cursor: pointer;
  display: ${(props) => (props.isChatLogExpanded ? "none" : "block")};
`;

export const StartButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  background-color: rgba(38, 93, 222, 0.9);
  border: 8px solid rgba(255, 255, 255, 1);
  color: #fff;
  border-radius: 50%;
  cursor: pointer;
  font-size: 84px !important;
  font-family: ${AI_CONCIERGE_FONT_FAMILY};
  font-weight: 700;
  width: 420px;
  height: 420px;

  @media (hover: hover) {
    &:hover {
      box-shadow: 0px 2px 4px 4px rgba(0, 0, 0, 0.2);
    }
  }
`;

export const ButtonsWrapper = styled.div`
  position: fixed;
  z-index: 3;
  top: 1000px;
  right: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 2rem;
  gap: 36px;
`;

export const ButtonComponent = styled.button<{ $isHome: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  background: ${(props) => (props.$isHome ? "#000" : "#5e5e5e")};
  border: 8px solid #fff;
  color: #fff;
  border-radius: 50%;
  cursor: pointer;
  font-family: ${AI_CONCIERGE_FONT_FAMILY};
  font-weight: 700;
  font-size: 48px !important;
  line-height: 1.2;
  width: 280px;
  height: 280px;
  gap: 8px;
  &:active {
    box-shadow: 0px 2px 4px 4px rgba(0, 0, 0, 0.2);
  }
`;

export const ButtonImage = styled.img`
  width: 72px;
  height: 72px;
`;
